import React, { useState } from "react";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import WorkflowFigure from "../WorkflowFigure";
import WorkflowPreviewModal from "../WorkflowPreviewModal";
import { WORKFLOW_CORE_STEPS } from "../landingData";

const WorkflowTeaser = () => {
    const [previewStep, setPreviewStep] = useState(null);

    return (
        <section className="clk-section clk-section-workflow alt" id="workflow">
            <div className="clk-container">
                <div className="clk-section-head clk-reveal">
                    <span className="clk-eyebrow"><span className="clk-dot" /> How it works</span>
                    <h2>One ticket, start to finish.</h2>
                    <p>
                        Follow a single customer request through Claritick, from the first email
                        to a resolved ticket with the customer kept in the loop.
                    </p>
                </div>

                <div className="clk-workflow-flow clk-workflow-flow--core">
                    {WORKFLOW_CORE_STEPS.map((step, i) => (
                        <WorkflowFigure
                            key={step.n}
                            step={step}
                            index={i}
                            onOpen={setPreviewStep}
                            showArrow={i < WORKFLOW_CORE_STEPS.length - 1}
                        />
                    ))}
                </div>

                <p className="clk-workflow-foot clk-reveal">
                    <Link to="/how-it-works" className="clk-inline-link">
                        See the full walkthrough <Icon name="arrow" size={16} className="clk-arrow" />
                    </Link>
                </p>
            </div>

            {previewStep && (
                <WorkflowPreviewModal
                    step={previewStep}
                    steps={WORKFLOW_CORE_STEPS}
                    onClose={() => setPreviewStep(null)}
                    onNavigate={setPreviewStep}
                />
            )}
        </section>
    );
};

export default WorkflowTeaser;
